import App from "../../app/App";
import Notifications from "../../app/Components/Notifications/Notifications";
import Forms from "../../app/Components/Forms/Forms";

const Login = {

    init() {

        this.el = $('[page="Login"]');

        if ( !this.el.length ) {
            return;
        }

        this.loading = this.el.find('.loading');
        this.form = this.el.find('form');

        Forms.init( this.form );
        Forms.focusFirstInput(this.form);

        this.bind();
    },

    bind() {
        this.form.submit((event) => {
            Forms.setSendData( Forms.inputData(Login.form) );
        });
    },

    showLoading() {
        $(this.loading).fadeIn(200);
    },

    hideLoading() {
        $(this.loading).fadeOut(2000);
    },

    beforeSend() {
        this.showLoading();
    },
}
export default Login;